export default __webpack_public_path__ + "static/media/2.38a3c7e4.webp";